// @ts-nocheck

import classNames from 'classnames';
import * as React from 'react';
import Icons from '../../../../styles/Icons';
type Props = {
  /**
   * The content that will appear when card is open.
   */
  children: React.ReactNode;

  /**
   * Callback from parent that is called whenever card header is clicked.
   */
  onClick?: () => void;

  /**
   * Determines if card is open or not (passed in by parent, box itself is stateless).
   */
  opened: boolean;

  /**
   * If true, clicking the header will not call this.onClick, and cursor will not display as pointer on hover.
   */
  disabled?: boolean;

  /**
   * For QA testing purposes, actual data-testid will be suffixed with "-collapsible-card"
   */
  testid: string;

  /**
   * For overriding/adding styles, applied to outer-most div
   */
  className?: string;

  /**
   * For overriding/adding styles, applied to header div
   */
  headerClassName?: string;

  /**
   * For overriding/adding styles, applied to div around children content
   */
  contentClassName?: string;

  /**
   * For overriding/adding styles, applied to div around arrow
   */
  arrowClassName?: string;

  /**
   * Optional element to be displayed on the right end when box is opened
   * OR closed & success is false (example is BinaryToggle buttons).
   */
  rightSideElement?: React.ReactElement<any> | null | undefined;

  /**
   * Appears to left side of box.
   */
  title?: React.ReactElement<any>;
};

function CollapsibleCard(props: Props) {
  const {
    children,
    onClick,
    opened,
    disabled,
    testid,
    className,
    headerClassName,
    contentClassName,
    arrowClassName,
    rightSideElement,
    title,
  } = props;
  return (
    <div className={classNames('collapsible-card', className)} data-testid={`${testid}-collapsible-card`}>
      <div
        data-testid={`${testid}-collapsible-card-header`}
        className={classNames(
          'collapsible-card__header',
          {
            'h_cur-p': !!onClick && !disabled,
          },
          headerClassName
        )}
        onClick={disabled ? null : onClick}
      >
        <div
          className={classNames('collapsible-card__arrow', arrowClassName)}
          data-testid={`${testid}-collapsible-card-arrow`}
        >
          <i className={classNames('material-icons')}>{opened ? Icons.KEYBOARD_ARROW_UP : Icons.KEYBOARD_ARROW_DOWN}</i>
        </div>
        <div
          className={classNames('collapsible-card__title', {
            'h_jc-fe': !title,
          })}
        >
          {title}
          {rightSideElement}
        </div>
      </div>
      <div
        data-testid={`${testid}-collapsible-card-content`}
        className={classNames('collapsible-card__content', contentClassName, {
          active: opened,
        })}
      >
        {children}
      </div>
    </div>
  );
}

export default CollapsibleCard;
